// LoadingIndicator.js
import React from 'react';
import './LoadingIndicator.css';

const LoadingIndicator = () => {
  return <div className="spinner"></div>;
};

export default LoadingIndicator;
